import { isAndroid, isIos } from '@braintree/browser-detection'
import React, { useEffect, useRef, useState } from 'react'
import { IVideoChapter } from '../@types/data'
import { useWindowSize } from '../context/WindowSizeContext'

interface IProps {
  data: IVideoChapter
  currentTime: number
  seekTime: number
  width: number
  first: boolean
  last: boolean
  // onActiveSection: (chapter: string, section: string) => void
}

// eslint-disable-next-line @typescript-eslint/comma-dangle
enum Alignment {
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
  CENTER = 'CENTER',
}

const VideoChapter: React.FC<IProps> = ({
  data,
  currentTime,
  seekTime,
  width,
  first,
  last,
}) => {
  const pipRef = useRef<HTMLDivElement>(null)
  const [active, setActive] = useState(false)
  const [alignment, setAlignment] = useState(Alignment.CENTER)
  const [caretOffset, setCaretOffset] = useState(0)
  const { dimensions } = useWindowSize()
  const isMobile = isAndroid() || isIos()

  const { time } = data
  const { start, end } = time
  let progress = currentTime > start ? (currentTime - start) / (end - start) : 0
  if (progress > 1) progress = 1

  // useEffect(() => {
  //   // if (keyframes == null) return
  //   if (currentTime > start && currentTime <= end) {
  //     // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
  //     const activeKeyframe = _.find(keyframes, (keyframe: IVideoKeyframe) => {
  //       return (
  //         currentTime > keyframe.time.start && currentTime <= keyframe.time.end
  //       )
  //     })
  //     onActiveSection(
  //       label,
  //       // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
  //       activeKeyframe !== undefined ? activeKeyframe.label : ''
  //     )
  //   }
  // }, [currentTime])
  useEffect(() => {
    if (pipRef?.current === null || width === 0) return
    const pipWidth = pipRef.current.getBoundingClientRect().width
    let offset = 0
    if (pipWidth > width) {
      if (first) {
        setAlignment(Alignment.LEFT)
        offset = (width - pipWidth) / 2
      }
      if (last) {
        setAlignment(Alignment.RIGHT)
        offset = (pipWidth - width) / 2
      }
    } else {
      setAlignment(Alignment.CENTER)
    }
    setCaretOffset(offset)
  }, [width, dimensions.width])

  useEffect(() => {
    if (seekTime >= 0) {
      if (seekTime >= data.time.start && seekTime < data.time.end) {
        setActive(true)
      } else {
        setActive(false)
      }
    } else {
      setActive(false)
    }
  }, [seekTime])

  const handleMouseOver = (): void => {
    if (isMobile) return
    setActive(true)
  }

  const handleMouseOut = (): void => {
    if (isMobile) return
    setActive(false)
  }

  const hitArea =
    'before:absolute before:inset-0 before:-bottom-[40px] before:bg-transparent'
  const caret =
    'absolute top-[100%] bg-transparent border-t-[6px] border-x-[6px] md:border-t-[9px] md:border-x-[9px] lg:border-t-[12px] lg:border-x-[12px] border-x-transparent border-t-black'

  return (
    <div
      style={{
        width: `${width}px`,
      }}
      className="relative h-1 bg-gray-medium grid"
      onMouseOver={handleMouseOver}
      onMouseOut={handleMouseOut}
      onMouseLeave={handleMouseOut}
    >
      <div
        className="absolute bg-gold w-full h-full duration-[50ms] origin-left transition-transform"
        style={{
          transform: `scaleX(${progress})`,
        }}
      />
      <div
        ref={pipRef}
        className={`absolute min-w-min px-3 py-1 md:px-4 md:py-2 lg:px-6 lg:py-2 -top-[40px] md:-top-[64px] lg:-top-[60px] xl:-top-[66px] flex flex-col items-center justify-center bg-black transition-transform-opacity origin-bottom pointer-events-none ${hitArea} ${
          active ? 'opacity-100 scale-100 pointer-events-auto' : 'opacity-0'
        }
        ${alignment === Alignment.LEFT ? 'justify-self-start' : ''}
        ${alignment === Alignment.RIGHT ? 'justify-self-end' : ''}
        ${alignment === Alignment.CENTER ? 'justify-self-center' : ''}`}
      >
        <h6 className="mr-2 leading-4 text-xs xl:text-sm uppercase text-gold tracking-wider whitespace-nowrap">
          {data.label}
        </h6>
        {/* <p className="text-[0.575rem] leading-4 md:text-[0.675rem] lg:text-xs xl:text-sm text-gold tracking-wide whitespace-nowrap -mt-[2px]">
          {data.label}
        </p> */}
        <div
          className={`${caret}`}
          style={{ transform: `translateX(${caretOffset}px)` }}
        />
      </div>
    </div>
  )
}

export default VideoChapter
